import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Integration } from "../../../types";
import { integrationService } from "../../../services/integrationService";

export const useCreateIntegration = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<Integration, "id" | "url">) => integrationService.create(input),
    onSuccess: (created) => {
      qc.setQueryData(["integration", created.id], created);
      qc.invalidateQueries({
        queryKey: ["integrations"]
      });
    },
  });
};
